import { apiSlice } from './apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Query to check authentication status
    getAuthStatus: builder.query({
      query: () => '/auth/status',
      providesTags: ['Auth'],
    }),
    
    // Query to get current user info
    getUser: builder.query({
      query: () => '/auth/user',
      providesTags: ['Auth'],
    }),
    
    // Mutation to logout
    logout: builder.mutation({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
      invalidatesTags: ['Auth', 'UserNodes'],
    }),
  }),
});

export const {
  useGetAuthStatusQuery,
  useGetUserQuery,
  useLogoutMutation,
} = authApi;

// Helper function to trigger login (redirects to backend)
export const loginWithDiscord = () => {
  window.location.href = '/api/auth/login'; // Use relative URL to work in both dev and prod
};

